// src/App.jsx
import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { MessagingProvider } from './contexts/MessagingContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import router from './router';
import { initSimpleSafariFix } from './utils/simpleSafarifix';
import './styles/global.css'; 
import JobApplications from './components/provider/JobApplications';

function App() {
  useEffect(() => {
    // Initialize Safari scroll fixes
    initSimpleSafariFix();
    
    // Debug info for mobile detection
    const isMobile = window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Add debug info to console
    console.log('📱 Mobile Detection:', {
      isMobile,
      screenWidth: window.innerWidth,
      userAgent: navigator.userAgent,
      devicePixelRatio: window.devicePixelRatio
    });

    // Add global error handler
    window.addEventListener('error', (event) => {
      console.error('Global error caught:', event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);
    });
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <MessagingProvider>
            <RouterProvider router={router} />
          </MessagingProvider>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;